import Store from '@/store';
import PTC_CadastroClienteClient from '@/api/PTC/PTC_CadastroCliente.client';
import Notifier from '@/libs/Notifier';

export default class PTC_CadastroClienteService {
  constructor() {
    this.client = new PTC_CadastroClienteClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async retornaClienteById() {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING', true);
      const data = await this.client.retornaClienteById(1);
      this.store.commit('PTC_CadastroClienteClient/SET_CLIENTE', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING', false);
    }
  }

  async RetornaEnderecoCliente() {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', true);
      const data = await this.client.RetornaEnderecoCliente(1);
      this.store.commit('PTC_CadastroClienteClient/SET_ENDERECO', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', false);
    }
  }

  async CreateEnderecoCliente(data) {
    data.clienteId = 1;
    data.clienteiderpenderecoentrega = null,
    data.clienteenderecoie = null,
    data.clienteiderp = null;
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', true);
      await this.client.CreateEnderecoCliente(data);
      this.notify.success('Endereço criado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', false);
    }
  }

  async UpdateEnderecoCliente(data) {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', true);
      await this.client.UpdateEnderecoCliente(1, data);
      this.notify.success('Endereço atualizado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', false);
    }
  }

  async DeleteEnderecoCliente(clienteId, tipoenderecoid) {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', true);
      await this.client.DeleteEnderecoCliente(clienteId, tipoenderecoid);
      this.notify.success('Endereço deletado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_ENDERECO', false);
    }
  }

  async RetornaContatos() {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', true);
      const data = await this.client.RetornaContatos(1);
      this.store.commit('PTC_CadastroClienteClient/SET_CONTATOS', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', false);
    }
  }

  async CreateContato(data) {
    data.clienteid = 1;
    data.clienteiderp = '464646';
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', true);
      await this.client.CreateContato(data);
      this.notify.success('Contato criado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', false);
    }
  }

  async UpdateContato(data) {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', true);
      await this.client.UpdateContato(1, data);
      this.notify.success('Contato atualizado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', false);
    }
  }

  async DeleteContato(clienteId, data) {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', true);
      await this.client.DeleteContato(clienteId, data);
      this.notify.success('Contato deletado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_CONTATOS', false);
    }
  }

  async RetornaTiposDocumento() {
    try {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_TIPOS_DOCUMENTO', true);
      const data = await this.client.RetornaTiposDocumento(1);
      this.store.commit('PTC_CadastroClienteClient/SET_TIPOS_DOCUMENTO', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_CadastroClienteClient/SET_IS_LOADING_TIPOS_DOCUMENTO', false);
    }
  }

  async executGet() {
    await this.retornaClienteById();
    await this.RetornaEnderecoCliente();
    await this.RetornaTiposDocumento();
    await this.RetornaContatos();
  }
}
